import { DomainMaritalStatusType } from "@porchpass/api-client";
import { useWebClientApi } from "src/api";
import {
  fromBorrowerPersonalInfo,
  toMaritalStatusUpdateReq,
  type PersonalInfoFormData,
} from "src/api/adapters";
import { useResponseRedirect } from "src/hooks";
import { useDlaFormSubmit } from "src/hooks/useDlaFormSubmit";
import { useFormLoad } from "src/hooks/useFormLoad";
import FormLayout from "src/layouts/FormLayout";
import { Col } from "src/components/layout";
import {
  FormTable,
  FormTableBody,
  MaritalStatusFields,
  WeddingIcon,
} from "@porchpass/ui";
import { useMemo } from "react";
import type { DtoBorrower } from "@porchpass/api-client";

const MARITAL_STATUS_TO_DLA: Record<string, string> = {
  [DomainMaritalStatusType.Married]: "MARRIED",
  [DomainMaritalStatusType.Separated]: "SEPARATED",
  [DomainMaritalStatusType.Unmarried]: "UNMARRIED",
};

export default () => {
  const api = useWebClientApi();
  const { formData } = useFormLoad<PersonalInfoFormData>(
    {},
    () => api.getBorrower(),
    (data) => fromBorrowerPersonalInfo(data as DtoBorrower),
  );
  const [submitHandler, loading, response] = useDlaFormSubmit(
    (data: PersonalInfoFormData) =>
      api.updateBorrower(toMaritalStatusUpdateReq(data)),
  );
  useResponseRedirect("/personal-info/dependents", response);

  const maritalValue = useMemo(
    () => ({
      maritalStatus:
        (Object.entries(MARITAL_STATUS_TO_DLA).find(
          ([, v]) => v === formData?.marital_status_type,
        )?.[0] as DomainMaritalStatusType) || "",
      dependentsAgesYears: formData?.originalDependentsArray,
    }),
    [formData],
  );

  return (
    <FormLayout
      title="What's your marital status?"
      headerTitle="Personal and Household"
      stepIndex={1}
      isLoading={loading}
    >
      <Col>
        <FormTable
          title="Marital Status"
          headerIcon={
            <WeddingIcon
              variant="bulk-rounded"
              size={16}
              className="text-primary"
            />
          }
        >
          <FormTableBody>
            <MaritalStatusFields
              value={maritalValue}
              showDependentsSection={false}
              onMaritalStatusChange={(status) => {
                void submitHandler({
                  marital_status_type: MARITAL_STATUS_TO_DLA[status],
                });
              }}
              onChange={() => {}}
            />
          </FormTableBody>
        </FormTable>
      </Col>
    </FormLayout>
  );
};
